//components
import {FilterStyleButton, IconLibrary, ThriveIcon} from "thrive-components"
import DropdownCheckboxMenu from  '@/components/elements/global/dropdown/DropdownCheckboxMenu';

//hooks
import UseFeedFilters from "./FeedFilters.hooks";



const FeedFilter = () => {
    const {feedFilters, filterCount, dropdownContainerRef, showDropdown, filterButtonLabel, filterButtonClassname, onClickFilterButton} = UseFeedFilters();

    return (
        <div className='editor-activity-feed-filter' ref={dropdownContainerRef}>
            <FilterStyleButton 
                ariaLabel={filterButtonLabel} 
                className={filterButtonClassname} 
                onButtonClick={onClickFilterButton}
                content={
                    <span>
                        {`Filter ${filterCount > 0 ? ` (${filterCount})` : ""}`}
                        <ThriveIcon iconName={IconLibrary.FILTERS} color="var(--thriveSky)" sizeInPx={"16"}/> 
                    </span>
                }
            />
        
            {showDropdown && 
                <DropdownCheckboxMenu 
                    checkboxMenus={feedFilters}
                />
            }  
        </div>
    );
};
export default FeedFilter